export default "__VITE_ASSET__f00fef63__"